import { render, staticRenderFns } from "./Appointment.vue?vue&type=template&id=4edef27c&"
import script from "./Appointment.vue?vue&type=script&lang=ts&"
export * from "./Appointment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports